import { BrandingThemeItem } from '@/types/brandingThemes';
import { SVButton } from '../core';
import BrandingThemeCopyDeleteDialog from './BrandingThemeCopyDeleteDialog';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';

type BrandingThemeDetailsHeaderButtonsProps = {
  brandingTheme: BrandingThemeItem;
  showEdit: boolean;
};

export default function BrandingThemeDetailsHeaderButtons({
  brandingTheme,
  showEdit,
}: BrandingThemeDetailsHeaderButtonsProps) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  const { uuid, name } = brandingTheme;

  return (
    <>
      {showEdit && (
        <SVButton
          fullWidth
          onClick={() =>
            navigate(`${ROUTES.BRANDING_THEME_EDIT_PARAMS}/${uuid}`)
          }
          variant="primary">
          Edit
        </SVButton>
      )}
      <SVButton
        fullWidth
        onClick={() => {
          setOpen(true);
          setIsDelete(false);
        }}
        variant="outlined">
        Copy
      </SVButton>
      <SVButton
        fullWidth
        onClick={() => {
          setOpen(true);
          setIsDelete(true);
        }}
        variant="error">
        Delete
      </SVButton>
      <BrandingThemeCopyDeleteDialog
        uuid={uuid}
        name={name}
        isDelete={isDelete}
        open={open}
        setOpen={setOpen}
        shouldNavigate
      />
    </>
  );
}
